import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { EmployerCard, EmployerCardHeader, EmployerCardImages, EmployerCardInfo, EmployerCardFooter } from './employer-card';
import { EyeSlashIcon } from '@heroicons/react/24/solid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerRestaurantCard(_ref) {
  var address = _ref.address,
      pictures = _ref.pictures,
      restaurantName = _ref.restaurantName,
      restaurantLogo = _ref.restaurantLogo,
      types = _ref.types,
      candidates = _ref.candidates,
      openJpsCount = _ref.openJpsCount,
      href = _ref.href,
      onClick = _ref.onClick,
      isShowcaseOffline = _ref.isShowcaseOffline;

  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var badgeVariant = openJpsCount ? 'success' : 'disabled';
  var bagdeText = openJpsCount ? translateCommon('open_positions', {
    count: openJpsCount
  }) : translateCommon('closed_positions');
  var restaurantTypes = useMemo(function () {
    return types === null || types === void 0 ? void 0 : types.map(function (type) {
      return type.type_var.label;
    }).join(', ');
  }, [types]);
  var images = useMemo(function () {
    return (pictures === null || pictures === void 0 ? void 0 : pictures.map(function (picture) {
      return picture.url;
    })) || [];
  }, [pictures]);
  return /*#__PURE__*/_jsxs(EmployerCard, {
    href: href,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(EmployerCardHeader, {
      badge: openJpsCount ? {
        text: bagdeText,
        variant: badgeVariant
      } : undefined,
      logo: restaurantLogo,
      title: restaurantName
    }), /*#__PURE__*/_jsx(EmployerCardImages, {
      images: images
    }), /*#__PURE__*/_jsx(EmployerCardInfo, {
      info: {
        address: address,
        businessName: restaurantTypes
      }
    }), !!(candidates !== null && candidates !== void 0 && candidates.candidates) && /*#__PURE__*/_jsx(EmployerCardFooter, {
      notification: {
        candidateCount: candidates === null || candidates === void 0 ? void 0 : candidates.count,
        message: candidates === null || candidates === void 0 ? void 0 : candidates.message,
        candidates: candidates === null || candidates === void 0 ? void 0 : candidates.candidates,
        isAllSpontaneous: candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous
      }
    }), isShowcaseOffline && /*#__PURE__*/_jsx(_StyledDiv, {
      children: /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsx(_StyledEyeSlashIcon, {}), /*#__PURE__*/_jsxs("span", {
          children: [translateCommon('the_showcase_for_this_venue_is'), " ", /*#__PURE__*/_jsx("strong", {
            children: translateCommon('offline')
          })]
        })]
      })
    })]
  });
}
export default EmployerRestaurantCard;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-cardrestaurant___StyledDiv",
  componentId: "sc-1knfzoj-0"
})({
  "display": "flex",
  "height": "100%",
  "alignItems": "flex-end"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-cardrestaurant___StyledDiv2",
  componentId: "sc-1knfzoj-1"
})({
  "display": "flex",
  "height": "2.5rem",
  "width": "100%",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "fontSize": "13px",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "0.875rem !important",
    "lineHeight": "1.25rem !important"
  }
});

var _StyledEyeSlashIcon = /*#__PURE__*/_styled(EyeSlashIcon).withConfig({
  displayName: "employer-cardrestaurant___StyledEyeSlashIcon",
  componentId: "sc-1knfzoj-2"
})({
  "height": "1rem",
  "width": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "height": "1.25rem",
    "minHeight": "20px",
    "width": "1.25rem",
    "minWidth": "20px"
  }
});